// Matches /:slug (property landing page).
// baseServer: "/search/" is set in vite.config.ts — vike strips the prefix
// before route matching, so urlPathname is already /:slug.
const route = "/@slug";
export default route;
